import { genderLables } from "keys/gender"
import { useEditTestTakerCell } from "pages/School/TestTakers/hooks/useColumns"
import { useMemo } from "react"
import TestTakerDetailsStatusCell from "../TestTakerDetailsStatusCell"
import { useSelector } from "react-redux"

const useTestTakerTableColumns = () => {
    const editTestTakerCell = useEditTestTakerCell()
    const { brokenDisplay } = useSelector(state => state.general)


    const columns = useMemo(
        () => [
            {
                accessorKey: 'test_taker_id',
                header: "ID",
                feature: "col_ID",
                role: "read",
                showBrokenDisplay: true,

            },
            {
                accessorKey: 'tz',
                header: "תעודת זהות",
                cell: (info) => info.getValue() || "?",
                showBrokenDisplay: true,

            },
            {
                accessorKey: 'test_taker_name',
                header: "שם",
                required: true,
                cell: (info) => info.getValue() || "?",
                showBrokenDisplay: true,

            },
            {
                accessorKey: "סטטוס",
                cell: TestTakerDetailsStatusCell,
                required: true
            },
            {
                accessorKey: 'gender',
                header: "מגדר",
                required: true,
                cell: (info) => genderLables?.[info.getValue()] || "?"
            },
            {
                accessorKey: 'language',
                header: "שפה עיקרית בבית",
                required: true,
                cell: (info) => info.getValue()?.label || info.getValue() || "?"
            },
            editTestTakerCell
        ], [brokenDisplay]
    )

    return columns
}

export default useTestTakerTableColumns